import {
  SET_CONTEST_DESCRIPTION,
  SET_CONTEST_PLACE,
  SET_CONTEST_SUCCESS,
  UNSET_CONTEST_SUCCESS
} from '@/store/mutation-types'
import { MAP_CENTER } from '@/assets/js/map'
import service from '@/service'
import router from '@/router'

const initialPlaceState = () => ({
  coords: MAP_CENTER,
  title: '',
  description: ''
})

const state = {
  place: initialPlaceState(),
  success: false
}

const getters = {
  currentContestStep (state) {
    const isPlacePicked = state.place.title
    const isPlaceDescription = state.place.description

    return isPlaceDescription
      ? 3
      : isPlacePicked
        ? 2
        : 1
  }
}

const mutations = {
  [SET_CONTEST_PLACE] (state, specs) {
    state.place = { ...state.place, ...specs }
  },
  [SET_CONTEST_DESCRIPTION] (state, description) {
    state.place.description = description
  },
  [SET_CONTEST_SUCCESS] (state) {
    state.success = true
    state.place = initialPlaceState()
  },
  [UNSET_CONTEST_SUCCESS] (state) {
    state.success = false
  }
}

const actions = {
  async applyContest ({ commit, state }, data) {
    const requestData = {
      lat: state.place.coords.lat,
      lng: state.place.coords.lng,
      address: state.place.title,
      description: state.place.description,
      participant_email: data.email,
      participant_name: data.name,
      terms_accepted: data.termsAgreement,
      personal_data_accepted: data.personalAgreement,
      commercial_info_accepted: data.commercialAgreement
    }

    try {
      await service.contest.submit(requestData)
      commit(SET_CONTEST_SUCCESS)
    } catch (err) {
      console.error(err)
    }

    commit(SET_CONTEST_SUCCESS)
    router.push({ name: 'contest-thanks' })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/contest.js